import { GITHUB_API_BASE } from '../github.const'

import { buildGithubHeaders } from './buildGithubHeaders'
import { resolveGithubToken } from './resolveGithubToken'

function encodeRepoFilePath(filePath: string): string {
  return filePath
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/')
}

/**
 * Private repo file body via the Contents API.
 * raw.githubusercontent.com does not accept Authorization, so a 404 there is not proof the file is missing.
 */
export async function fetchRepositoryFileRaw(repo: string, branch: string, filePath: string): Promise<string | null> {
  if (!resolveGithubToken()) return null

  const encodedPath = encodeRepoFilePath(filePath)
  const url = `${GITHUB_API_BASE}/${repo}/contents/${encodedPath}?ref=${encodeURIComponent(branch)}`
  const response = await fetch(url, {
    headers: buildGithubHeaders('application/vnd.github.raw+json'),
    cache: 'force-cache',
  })

  if (!response.ok) {
    console.error(`Failed to fetch "${filePath}" via GitHub API: ${response.status} ${response.statusText}`)
    return null
  }

  return response.text()
}
